export default __webpack_public_path__ + "static/media/secondPosition.50f6da01.svg";